import { render, staticRenderFns } from "./SwitchClub.vue?vue&type=template&id=05e3d40b&"
import script from "./SwitchClub.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SwitchClub.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e3d40b')) {
      api.createRecord('05e3d40b', component.options)
    } else {
      api.reload('05e3d40b', component.options)
    }
    module.hot.accept("./SwitchClub.vue?vue&type=template&id=05e3d40b&", function () {
      api.rerender('05e3d40b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/LpuFilters/components/SwitchClub/SwitchClub.vue"
export default component.exports